import Header from './components/Header';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <FaqSection />
        <CardsSection />
        <FeaturesSection />
        <TopicsSection />
        <AppSection />
        <AboutSection />
        <CarouselSection />
        <CommentsSection />
        <MediaSection />
        <UpdatesSection />
        <ContactSection />
        <IndexSection />
        <RankingSection />
      </main>
      <Footer />
    </div>
  );
}